import * as React from "react";

import Help from "@material-ui/icons/HelpTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import CardList from "~/components/CustomerSupport/CardList";
import Topic from "~/components/CustomerSupport/Topic";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import { StyledCard as Card } from "~/layouts/StyledCard";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";

class RMAThankYou extends React.Component<WithTranslation> {
  public render() {
    const { t } = this.props;

    return (
      <SupportDashboardLayout>
        <CardList>
          <Card>
            <Topic
              title={t("header.title")}
              description={t("header.description")}
              icon={Help}
            />
          </Card>

          <Callout intent="success" title={t("thankYou.callout.title")}>
            <div>{t("thankYou.callout.description")}</div>
          </Callout>
        </CardList>
      </SupportDashboardLayout>
    );
  }
}

export default withTranslation("rmaForm")(RMAThankYou);



// WEBPACK FOOTER //
// ./src/pages/RMA/RMAThankYou.tsx